import DragIcon from "@assets/icons/drag.svg";
import { Exercise } from "@domain/exercise/exercise";
import styled from "@emotion/styled";
import { CARD_BORDER_SIZE } from "@ui/pages/program-builder/day-table/day-exercise-placeholder";
import { BodyPartIcon } from "@ui/components/exercise/body-part-icon";
import { absoluteFillObject, row } from "@ui/style";
import { colors } from "@ui/style/colors";
import React from "react";

interface RowExerciseCardProps {
	exercise: Exercise;
	disabled?: boolean;
	onClick?: () => void;
}

export const RowExerciseCard: React.FC<RowExerciseCardProps> = ({ exercise, disabled = false, onClick }) => (
	<RowExerciseContainer onClick={onClick} disabled={disabled}>
		<Thumbnail src={exercise.thumbnails.mediumThumbnailUrl} />
		<ExerciseTitle className="p-size-s-rubik-medium">{exercise.title}</ExerciseTitle>
		<BodyPartIcon
			bodyPart={exercise.primaryBodyPart}
			additionalBodyPartsCount={exercise.secondaryBodyParts.length}
			width={24}
			height={24}
			style={{ filter: disabled ? "grayscale(1)" : "" }}
		/>
		<DragIcon width={20} height={20} color={colors.grey25} />
		{disabled && <Overlay />}
	</RowExerciseContainer>
);

const RowExerciseContainer = styled.div<{ disabled: boolean }>`
	position: relative;
	${row(12, "flexstart", "center")};
	border: ${CARD_BORDER_SIZE}px solid ${colors.primary10};
	border-radius: 8px;
	flex: none;
	padding: 8px;
	background: ${colors.white};
	:hover {
		border-color: ${({ disabled }) => (disabled ? colors.primary10 : colors.primary25)};
	}
`;

const Thumbnail = styled.img`
	cursor: pointer;
	height: 64px;
	width: 64px;
	object-fit: cover;
	border-radius: 2px;
`;

const ExerciseTitle = styled.div`
	cursor: pointer;
	flex: 1;
`;

const Overlay = styled.div`
	${absoluteFillObject}
	background-color: ${colors.grey5};
	opacity: 0.4;
`;
